let mainPath = "/alterationtypes";
let viewFolder = "AlterationType";

module.exports = [
    {
        path: mainPath,
        name: 'alterationTypes',
        component: () => import(/* webpackChunkName: "Warehouse" */ '../views/'+viewFolder+'/Index.vue'),
        // beforeEnter: (to, from, next) => {
        //   if (!localStorage.getItem('userId')) next({ name: 'Home' })
        //   else next()
        // }
    }
]